import React from 'react';
import { FormGroup } from 'reactstrap';
import ContinentCountrySelect from '../../components/ContinentCountrySelect';
import Checkbox from '../../components/Checkbox/Checkbox';

const UserModalDestinationSection = ({
  allowed_destination_countries,
  onChange,
  onNonGeoChange,
  activeLanguage,
  translate
}) => {
  return (
    <FormGroup>
      <span className="modal-help-text mb-2">
        {translate('user_management_destination_countries-warning')}
      </span>
      <ContinentCountrySelect
        selected={allowed_destination_countries}
        onChange={onChange}
        activeLanguage={activeLanguage}
        translate={translate}
        prefix="dest"
      />
      <FormGroup check className="checkbox">
        <Checkbox
          id="dest_user_modal_001"
          name="001"
          defaultChecked={allowed_destination_countries.includes('001')}
          onChange={onNonGeoChange}
          label={translate('user_management_non_geo_countries')}
        />
      </FormGroup>
      <span className="modal-help-text">
        {translate('user_management_non_geo_numbers_tooltip')}
      </span>
    </FormGroup>
  );
};

export default UserModalDestinationSection;
